var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettingsBorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings",
    transform: "translate(-1856 -125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_12258",
    "data-name": "Rectangle 12258",
    transform: "translate(1857 126)",
    fill: "#f4f5f9",
    stroke: "#0074d7",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -0.5,
    width: 49,
    height: 49,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "settings_black_24dp_2_",
    "data-name": "settings_black_24dp (2)",
    transform: "translate(1869 138)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12260",
    "data-name": "Rectangle 12260",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47209",
    "data-name": "Path 47209",
    d: "M19.5,12c0-.23-.01-.45-.03-.68l1.86-1.41a1.006,1.006,0,0,0,.26-1.3L19.72,5.38a.987.987,0,0,0-1.25-.42l-2.15.91a7.587,7.587,0,0,0-1.17-.68l-.29-2.31A1,1,0,0,0,13.87,2H10.14a1,1,0,0,0-1,.88L8.85,5.19a7.587,7.587,0,0,0-1.17.68L5.53,4.96a.987.987,0,0,0-1.25.42L2.41,8.62a1.008,1.008,0,0,0,.26,1.3l1.86,1.41c-.02.22-.03.44-.03.67s.01.45.03.68L2.67,14.09a1.006,1.006,0,0,0-.26,1.3l1.87,3.23a.987.987,0,0,0,1.25.42l2.15-.91a7.587,7.587,0,0,0,1.17.68l.29,2.31a1,1,0,0,0,.99.88h3.73a1,1,0,0,0,.99-.88l.29-2.31a7.587,7.587,0,0,0,1.17-.68l2.15.91a.987.987,0,0,0,1.25-.42l1.87-3.23a1.008,1.008,0,0,0-.26-1.3l-1.86-1.41A5.17,5.17,0,0,0,19.5,12Zm-7.46,3.5a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,12.04,15.5Z",
    fill: "#0074d7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsBorder);
export default __webpack_public_path__ + "static/media/settings_border.1b4a7462e06ef1cd98600bbe0e06fa5a.svg";
export { ForwardRef as ReactComponent };